import { Controller } from "@hotwired/stimulus"

// Lösch-Checkliste "Meine offenen": bestätigte Zeilen werden per Turbo-Stream sofort
// entfernt (kein störender Reload pro Klick). Sobald die aktuelle Seite dadurch keine
// Zeilen mehr hat, laden wir den deletion_checklist-Frame einmalig nach → die nächste
// Charge und die Pagination werden frisch gerendert (kein übersprungener Datensatz).
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.observer = new MutationObserver(() => this.checkEmpty())
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  checkEmpty() {
    if (this.element.querySelectorAll("tr").length > 0) return
    const frame = this.element.closest("turbo-frame")
    if (frame && this.urlValue) {
      frame.src = this.urlValue
    }
  }
}
